import React from "react";

type Plan = {
    name: "Go" | "Plus" | "Premium";
    price: number;
    features: string[];
};

const plans: Plan[] = [
    {
        name: "Go", price: 199, features: [
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            "10 AI Invocations / month",
            "Export Documents To PDF Only",
            "Unlimited client accounts",
            "10 File Uploads / month",
        ]
    },
    {
        name: "Plus", price: 299, features: [
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            "10 AI Invocations / month",
            "Export Documents To PDF Only",
            "Unlimited client accounts",
            "10 File Uploads / month",
        ]
    },
    {
        name: "Premium", price: 699, features: [
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            "10 AI Invocations / month",
            "Export Documents To PDF Only",
            "Unlimited client accounts",
            "10 File Uploads / month",
        ]
    },
];

const BulletIcon = () => (
    <svg
        className="shrink-0 h-5 w-5"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
    >
        <rect x="1.25" y="1.25" width="17.5" height="17.5" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
        <path d="M6.5 10.5l2.25 2.25 4.75-5.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Price = ({ value }: { value: number }) => (
    <div className="flex items-start gap-2">
        <span className="text-[18px] leading-none mt-[6px] font-semibold">$</span>
        <span className="text-[56px] leading-none font-extrabold tracking-tight">{value}</span>
    </div>
);

export default function Plans() {
    return (
        <section className="py-16 px-8 mx-auto max-w-[1100px]">

            <h2 className="text-5xl font-bold mb-12 text-center">Plans</h2>

            <div className="grid gap-8 md:grid-cols-3">
                {plans.map((p) => {
                    const isPlus = p.name === "Plus";
                    const isLightCard = p.name !== "Plus";

                    return (
                        <article
                            key={p.name}
                            className={[
                                "relative rounded-[18px] border shadow-sm",
                                "px-8 pt-9 pb-8",
                                "md:px-10 md:pt-10 md:pb-9",
                                isPlus ? "bg-[#8CC38F]" : "bg-white",
                                "ring-1 ring-black/5",
                            ].join(" ")}
                        >
                            <h3 className="text-[22px] font-semibold mb-5">{p.name}</h3>

                            <div className="flex items-center gap-3">
                                <Price value={p.price} />
                                <p className="text-sm text-black/70 max-w-[250px]">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                </p>
                            </div>

                            <ul className="mt-7 space-y-4 text-[14.5px]">
                                {p.features.map((f, i) => (
                                    <li key={i} className="flex items-start gap-3">
                                        <span
                                            className={[
                                                "mt-[2px] text-black",
                                                isPlus ? "text-black" : "text-black/80",
                                            ].join(" ")}
                                        >
                                            <BulletIcon />
                                        </span>
                                        <span className="text-black font-semibold">{f}</span>
                                    </li>
                                ))}
                            </ul>

                            {/* CTA */}
                            <div className="mt-9">
                                {p.name === "Go" && (
                                    <button
                                        className={[
                                            "w-full h-[44px] rounded-[10px]",
                                            "border border-[#6BB974] text-[#2A6A35] font-medium",
                                            "hover:bg-[#eff8f0] transition-colors",
                                        ].join(" ")}
                                    >
                                        Current Plan
                                    </button>
                                )}

                                {p.name === "Plus" && (
                                    <button
                                        className={[
                                            "w-full h-[48px] rounded-[10px]",
                                            "bg-[#1f1f1f] text-white font-medium",
                                            "flex items-center justify-center gap-3",
                                            "hover:opacity-95 transition",
                                        ].join(" ")}
                                    >
                                        <span className="inline-block h-4 w-4 rounded-full border-2 border-white" />
                                        Explore Plus
                                    </button>
                                )}

                                {p.name === "Premium" && (
                                    <button
                                        className={[
                                            "w-full h-[44px] rounded-[10px]",
                                            "bg-[#8CC38F] text-[#1f1f1f] font-medium",
                                            "flex items-center justify-center gap-3",
                                            "hover:brightness-95 transition",
                                        ].join(" ")}
                                    >
                                        <span className="inline-block h-4 w-4 rounded-full border-2 border-[#1f1f1f]" />
                                        Explore Premium
                                    </button>
                                )}
                            </div>
                            {isLightCard && (
                                <div className="pointer-events-none absolute inset-0 rounded-[18px] ring-1 ring-black/5" />
                            )}
                        </article>
                    );
                })}
            </div>

        </section>
    );
}
